import { render, staticRenderFns } from "./deliveryGoodsBox.vue?vue&type=template&id=069cb6f2&scoped=true&lang=html&"
import script from "./deliveryGoodsBox.vue?vue&type=script&lang=js&"
export * from "./deliveryGoodsBox.vue?vue&type=script&lang=js&"
import style0 from "./deliveryGoodsBox.vue?vue&type=style&index=0&id=069cb6f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069cb6f2",
  null
  
)

export default component.exports